// extracted by mini-css-extract-plugin
export default {"checkboxRound":"SavedItem_checkboxRound__T9Wlt","customCss":"SavedItem_customCss__V1nVk"};